// extracted by mini-css-extract-plugin
export default {"tablePaper":"InventoryTable_tablePaper__BmZ0s","dataGrid":"InventoryTable_dataGrid__18nQ9"};